import { createElement } from 'react';
import { RouteObject, redirect } from 'react-router-dom';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';
import { pathKeys } from 'shared/lib/react-router';

import AccountCreatePage from './AccountCreatePage';

export const accountCreatePageRoute: RouteObject = {
  path: 'create/',
  element: createElement(AccountCreatePage),
  loader: async (args) => {
    const requiredPermissions = replacePermissions(pathPermissions.account.create, args.params);
    if (!isHasAccess(requiredPermissions)) {
      return redirect(pathKeys.dashboard());
    }

    return args;
  },
};
